module.exports = __webpack_public_path__ + "media/categories/dyson_sphere-81a4b371.png";